/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ScheduleType } from '../models/ScheduleType';

export class BackupSchedule {
  /**
  * The ID of the schedule
  */
  'id': string;
  /**
  * The ID of the backup vault
  */
  'vaultId'?: string;
  /**
  * The region where backups will be stored
  */
  'region'?: string;
  /**
  * The backup windows cron expression
  */
  'windows': string;
  /**
  * Whether the backup windows is in UTC rather than the resource region timezone
  */
  'useUtc'?: boolean;
  /**
  * The backup windows duration in minutes
  */
  'duration': number;
  /**
  * The backup retention in days
  */
  'backupRetention': number;
  /**
  * The archive retention in days
  */
  'archiveRetention'?: number;
  'scheduleType': ScheduleType;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "windows",
      "baseName": "windows",
      "type": "string",
      "format": ""
    },
    {
      "name": "useUtc",
      "baseName": "useUtc",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "duration",
      "baseName": "duration",
      "type": "number",
      "format": ""
    },
    {
      "name": "backupRetention",
      "baseName": "backupRetention",
      "type": "number",
      "format": ""
    },
    {
      "name": "archiveRetention",
      "baseName": "archiveRetention",
      "type": "number",
      "format": ""
    },
    {
      "name": "scheduleType",
      "baseName": "scheduleType",
      "type": "ScheduleType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupSchedule.attributeTypeMap;
  }

  public constructor() {
  }
}



